import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';

const PageQuizz = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('quizz')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    return (
        <div>
            <h1>Quizz</h1>
            <p>Nous vous fournissons une suite de Quizz sur les différents domaines de l'UV. Ils vont vous permettre de vous tester et vous donner une idée de si vous avez les compétences nécessaires pour réussir le domaine.</p>
            <Button align="center" to={`${process.env.PUBLIC_URL}/quizz/1/test.html`} type="extern">Quizz sur le domaine 1</Button>
            <Button align="center" to={`${process.env.PUBLIC_URL}/quizz/2/test.html`} type="extern">Quizz sur le domaine 2</Button>
            <Button align="center" to={`${process.env.PUBLIC_URL}/quizz/3/test.html`} type="extern">Quizz sur le domaine 3</Button>
            <Button align="center" to={`${process.env.PUBLIC_URL}/quizz/4/test.html`} type="extern">Quizz sur le domaine 4</Button>
            <Button align="center" to={`${process.env.PUBLIC_URL}/quizz/5/test.html`} type="extern">Quizz sur le domaine 5</Button>
            <Button align="center" icon="arrow-right" to="?page=tutoriels">Tutoriels</Button>
        </div>
    );
}

export default PageQuizz;